import Vue from "vue";
import { STATUS_DRAFT, STATUS_PUBLISH, STATUS_PENDING } from "./const";
const plugin = {
  install(Vue) {
    // 4. add an instance method
    Vue.prototype.$informasi = {
      statusColor: status => {
        switch (+status) {
          case STATUS_PUBLISH:
            return "success";
          case STATUS_PENDING:
            return "pending";
          case STATUS_DRAFT:
            return "black";
          default:
            return "grey";
        }
      },
      STATUS_DRAFT,
      STATUS_PUBLISH,
      STATUS_PENDING
    };
  }
};

Vue.use(plugin);
